/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteDraftSource;

(function (QuoteDraftSource) {
  QuoteDraftSource["JOVE"] = "jove";
  QuoteDraftSource["ACTURIS"] = "acturis";
})(QuoteDraftSource || (QuoteDraftSource = {}));